/**
 * File Configuration
 * Centralized configuration for file handling, uploads, and constraints
 */

export const FILE_CONFIG = {
  // Supported file types
  AUDIO: {
    EXTENSIONS: ['.wav', '.mp3'],
    MIME_TYPES: ['audio/wav', 'audio/mpeg', 'audio/mp3'],
    ACCEPT_STRING: '.wav,.mp3',
    EXTENSION_PATTERN: /\.(wav|mp3)$/i,
  },

  IMAGE: {
    EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
    MIME_TYPES: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    ACCEPT_STRING: '.jpg,.jpeg,.png,.gif,.webp',
  },

  // File size limits (in bytes)
  SIZE_LIMITS: {
    AUDIO: {
      MAX_SIZE: 100 * 1024 * 1024, // 100MB
      RECOMMENDED_SIZE: 50 * 1024 * 1024, // 50MB
    },
    IMAGE: {
      MAX_SIZE: 10 * 1024 * 1024, // 10MB
      RECOMMENDED_SIZE: 2 * 1024 * 1024, // 2MB
    },
  },

  // Upload configuration
  UPLOAD: {
    MAX_CONCURRENT: 3,
    CHUNK_SIZE: 1024 * 1024, // 1MB chunks
    RETRY_ATTEMPTS: 3,
    TIMEOUT: 120000, // 2 minutes
    
    // Progress thresholds
    PROGRESS_UPDATE_INTERVAL: 100, // ms
  },

  // Track type options
  TRACK_TYPES: [
    'Full Track',
    'Variation',
    'Stripped',
    'Cutdown',
    '60',
    '45',
    '30',
    '20',
    '15',
    '6',
    '5',
    '3',
    'Instrumental_60',
    'Instrumental_45',
    'Instrumental_30',
    'Instrumental_20',
    'Instrumental_15',
    'Instrumental_6',
    'Instrumental_5',
    'Instrumental_3',
    'Variation_60',
    'Variation_45',
    'Variation_30',
    'Variation_20',
    'Variation_15',
    'Variation_6',
    'Variation_5',
    'Variation_3',
    'Stripped_60',
    'Stripped_45',
    'Stripped_30',
    'Stripped_20',
    'Stripped_15'
  ],

  // File naming patterns
  NAMING: {
    // Pattern for extracting base name from files
    BASE_NAME_PATTERN: /^(.+)(?:\.(wav|mp3))$/i,
    
    // Invalid characters in filenames
    INVALID_CHARS: /[<>:"/\\|?*]/g,
    
    // Maximum filename length
    MAX_FILENAME_LENGTH: 255,
  },

  // Validation messages
  VALIDATION: {
    REQUIRED_PAIRS: 'All files must have both .wav and .mp3 pairs.',
    FILE_TOO_LARGE: 'File size exceeds maximum allowed size.',
    INVALID_TYPE: 'File type not supported.',
    NO_FILES_SELECTED: 'Please select at least one file.',
    UPLOAD_FAILED: 'File upload failed. Please try again.',
  },
};

export default FILE_CONFIG;